import React, { useEffect, useState } from 'react';
import { Modal, Spin, Tag } from 'antd';
import { comparePromptVersions, CompareResultVo, DiffItemVo } from '@/api/prompt';

export interface CompareVersionProp {
  fromVersionId: number;
  toVersionId: number;
  onCancel: () => void;
}

const CompareVersion = ({ fromVersionId, toVersionId, onCancel }: CompareVersionProp) => {
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState<CompareResultVo>();

  useEffect(() => {
    setLoading(true);
    comparePromptVersions({ fromVersionId, toVersionId })
      .then(res => setResult(res))
      .finally(() => setLoading(false));
  }, [fromVersionId, toVersionId]);

  const renderDiff = (diff: DiffItemVo[]) => {
    if (!diff || diff.length === 0) {
      return <div style={{ color: '#999' }}>两个版本内容相同</div>;
    }
    return (
      <div style={{ fontFamily: 'monospace', fontSize: 13, lineHeight: 1.6 }}>
        {diff.map((item, idx) => (
          <div key={idx} style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ width: 40, color: '#999', textAlign: 'right', paddingRight: 8 }}>
              {item.lineNumber}
            </span>
            <Tag color={item.type === 'add' ? 'green' : item.type === 'delete' ? 'red' : 'blue'}>
              {item.type === 'add' ? '+' : item.type === 'delete' ? '-' : '~'}
            </Tag>
            <span style={{
              backgroundColor: item.type === 'add' ? '#e6f7e6' : item.type === 'delete' ? '#ffe6e6' : '#e6f0ff',
              padding: '2px 4px',
              flex: 1,
            }}>
              {item.content}
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Modal
      title="版本对比"
      open={true}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <Spin spinning={loading}>
        {result && (
          <div>
            <div style={{ marginBottom: 16 }}>
              <strong>对比版本：</strong> v{fromVersionId} → v{toVersionId}
            </div>
            <div style={{ marginBottom: 8 }}>
              <strong>差异内容：</strong>
              <div style={{ marginTop: 8, maxHeight: 400, overflow: 'auto', border: '1px solid #d9d9d9', padding: 12 }}>
                {renderDiff(result.diff)}
              </div>
            </div>
          </div>
        )}
      </Spin>
    </Modal>
  );
};

export default CompareVersion;